import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePreviewContext } from '../providers/PreviewProvider';
import { useWorkspaceContext } from '../providers/WorkspaceProvider';
import ResumeCanvas from './ResumeCanvas';
import CoverLetterCanvas from './CoverLetterCanvas';
import SectionReorderPanel from './SectionReorderPanel';
import WorkspaceToolbar from '../toolbar';

export default function WorkspacePreview() {
  const location = useLocation();
  const {
    theme,
    resumeAreaRef,
    activeCoverLetter,
  } = usePreviewContext();

  const { mobileTab } = useWorkspaceContext();

  const [isMobile, setIsMobile] = React.useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isCoverLetterPage = location.pathname.includes('/cover-letter');

  return (
    <div
      id="resume-canvas-container"
      className={`${mobileTab !== 2 ? 'hidden' : 'flex flex-1'} md:flex md:flex-1 flex-col overflow-hidden transition-all duration-300`}
      style={{
        background: 'transparent',
      }}
    >
      {isCoverLetterPage ? (
        <CoverLetterCanvas />
      ) : (
        <div className="flex-1 relative overflow-hidden h-full">
          {/* Viewport scrolling container (takes full height) */}
          <div
            ref={resumeAreaRef}
            className="absolute inset-0 overflow-auto select-none"
            style={{
              '--color-bg-canvas': theme === 'dark' ? '#09090b' : '#f8fafc',
              background: 'var(--color-bg-canvas)',
              backgroundImage: theme === 'dark'
                ? 'radial-gradient(circle, rgba(255,255,255,0.05) 1px, transparent 1px)'
                : 'radial-gradient(circle, rgba(0,0,0,0.04) 1px, transparent 1px)',
              backgroundSize: '24px 24px',
              padding: isMobile ? '116px 12px 40px 12px' : '72px 24px 40px 24px',
              scrollBehavior: 'smooth',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }}
          >
            <ResumeCanvas />
          </div>

          {/* Floating actions bar (Menu, Undo/Redo) absolute positioned */}
          <WorkspaceToolbar />

          {/* Reorder actions overlay */}
          <SectionReorderPanel />
        </div>
      )}
    </div>
  );
}
